import { SectionLayout } from "@/shared/ui/layouts/SectionLayout";
import Typography from "@/shared/ui/Typography";

import { NavLink } from "react-router-dom";
import CalculatorButton from "@/shared/ui/buttons/CalculatorButton";

export function MortgageSection() {
    return (
        <SectionLayout 
            className=""
            containerClassName="relative flex pt-[40px] pb-[20px] md:py-[40px] md:items-center md:flex-row md:gap-[20px] lg:gap-[80px]"
        >
            <div className="flex flex-col gap-[20px] md:gap-[32px] md:flex-1">
                <Typography tag="h2">
                    Рассчитайте стоимость ипотеки
                </Typography>
                <div className="max-w-[600px] flex flex-col gap-[16px] md:gap-[20px]">
                    <Typography className="uppercase font-semibold text-[16px] md:text-[18px] !leading-[120%]">
                        поможем узнать условия кредита и сделать осознанный выбор.
                    </Typography>
                    <Typography className="uppercase font-normal text-[14px] md:text-[16px] !leading-[120%]">
                        Пусть ваш путь к новому дому будет простым и понятным!
                    </Typography>
                </div> 
                
                <NavLink to="/mortgage" className="w-full">
                    <CalculatorButton className="w-full">
                        Перейти к ипотечному калькулятору
                    </CalculatorButton>
                </NavLink>
            </div>
            <img 
                src="/images/defaults/mortgage.png"
                className="hidden md:block w-[280px] h-[274px] lg:w-[167px] lg:h-[176px]"
                alt=""
            />
        </SectionLayout>
    );
}
